<template>
  <div class="blocking-alert">
    <div class="blocked-url one-liner">
      {{ title }}
    </div>

    <div class="blocking-message">
      {{ message }}
    </div>

    <div class="btn-group">
      <div class="btn btn-cancel" @click="$emit('close')">
        {{ $t("cancel") }}
      </div>

      <div class="btn btn-confirm" @click="confirm">
        {{ $t("ok") }}
      </div>
    </div>
  </div>
</template>

<script>
  import { titleText } from '@/constants/requests'
  import { getDomain } from '@/services/utils.js'

  import errorNotification from '@/mixins/errorNotification.js'

  export default {
    mixins: [
      errorNotification
    ],

    props: {
      request: {
        required: true
      },

      action: {
        required: true
      }
    },

    computed: {
      ...mapGetters('children', {
        getChildById: 'getById',
      }),

      ...mapGetters('auth', {
        currentUser: 'currentUser'
      }),

      groupId() {
        return this.currentUser.group_id
      },

      child() {
        return this.getChildById(this.request.user_id)
      },

      title() {
        if (!this.request) {
          return 'Request Access'
        }

        return titleText[this.request.type]
      },

      message() {
        if (this.action === 'ignore') {
          return 'Ignore this request?'
        }

        if (this.action === 'ignoreAll') {
          return 'Ignore all requests?'
        }

        return `This will add ${ getDomain(this.request.param) } to ${ this.child.name } whitelist.`
      }
    },

    methods: {
      ...mapActions('requests', {
        denyRequest: 'denyRequest',
        denyAll: 'denyAll',
        grantRequest: 'grantRequest'
      }),

      ignore() {
        this.denyRequest(this.request)
          .catch(() => {
            this.failedRequestNotification()
          })
      },

      ignoreAll() {
        this.denyAll(this.currentUser.group_id)
          .catch(() => {
            this.failedRequestNotification()
          })
      },

      grant() {
        this.grantRequest(this.request)
          .catch(() => {
            this.failedRequestNotification()
          })
      },

      confirm() {
        if (this.action === 'ignore') {
          this.ignore()
          this.$emit('close')

          return
        }

        if (this.action === 'ignoreAll') {
          this.ignoreAll()
          this.$emit('close')

          return
        }

        this.grant()
        this.$emit('close')
      }
    }
  }
</script>

<style lang="scss" scoped>
  .blocking-alert {

    .blocking-message {
      font-size: 12px;
      margin: 12px 0 30px 0;
    }

    .btn-group {
      display: flex;
      justify-content: center;
      align-items: center;

      margin: 0 10px 0 10px;
      font-size: 12px;

      .btn {
        width: 60px;
        height: 25px;

        border-radius: 2px;
        padding: 7px 0;
        margin-right: 12px;

        color: #fff;
        font-weight: bold;
        text-align: center;
        cursor: pointer;
      }

      .btn-confirm {
        background: #22c883;
      }

      .btn-cancel {
        background: #f35f5f;
      }
    }
  }
</style>